export default {
    namespaced: true,
    state: {
        state: 'WELCOME', // OR QUEST
        message: "",
        campaignId: null,
        options: [],
        quest: null
    },
    getters: {
        data(state) {
            return state;
        },
        quest(state) {
            return state.quest;
        },
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        questClaimed(state) {
            if(state.quest)
                state.quest.status = 'FINISHED';
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        questClaimed({ commit }) {
            commit('questClaimed');
        }
    }
};